/* eslint-disable indent */
/* eslint-disable comma-dangle */
/* eslint-disable no-trailing-spaces */

type StaticImages = {
    readonly [fileName: string]: {
        uri?: string;
    };
}

const imageStaticSourcesByFileName: StaticImages = {
    'tFi6JRoeUybz9EcLw8C2eF.png': { uri: './images/tFi6JRoeUybz9EcLw8C2eF.png' },
'd6cYbqzuDa45ZzobNC7VWc.png': { uri: './images/d6cYbqzuDa45ZzobNC7VWc.png' },
'gLUkktybki28whM6wZYCRZ.png': { uri: './images/gLUkktybki28whM6wZYCRZ.png' },
'9PamL3ibDbCpMfLvVGRU6K.png': { uri: './images/9PamL3ibDbCpMfLvVGRU6K.png' },
'24AhXLnjGh8WnZjc9Up7Bv.png': { uri: './images/24AhXLnjGh8WnZjc9Up7Bv.png' },
'tW6HzmNv1JDE9wkpJq5GVS.jpg': { uri: './images/tW6HzmNv1JDE9wkpJq5GVS.jpg' },
'khSYAe5c5rSRhPVA4vqrXw.png': { uri: './images/khSYAe5c5rSRhPVA4vqrXw.png' }
}

export default imageStaticSourcesByFileName
